import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LegalAcceptanceGuard } from './legal-acceptance.guard';

/** The old template pages; links to them may still be out there. */
export const LEGAL_REDIRECTS: Route[] = [
    { path: 'terms', pathMatch: 'full', redirectTo: 'legal/terms' },
    { path: 'privacy', pathMatch: 'full', redirectTo: 'legal/privacy' },
];

/**
 * Guards of the admin and user trees: the session first (`canActivate`), then the legal
 * acceptance gate on every child (`canActivateChild` runs only after `canActivate` passed).
 */
export const GATED_TREE_GUARDS = {
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard, LegalAcceptanceGuard],
} satisfies Pick<Route, 'canActivate' | 'canActivateChild'>;
